import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctions } from '../common-functions';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class PaymentGatewayService {
  public isLoggedIn: boolean = false;
  public server = environment.APIEndpoint;
  public deviceMetaInfo = {
    "appVersion": "",
    "deviceCountry": "India",
    "deviceCity": "",
    "deviceId": localStorage.getItem("deviceId"),
    "deviceModel": "",
    "platform": "WEB",
    "deviceOSVersion": ""
  };
  public urls: any = {
    initiateTxn: this.server + 'api/order/transaction/v3/initiate',
    unsecInitiateTxn: this.server + 'api/unsec/order/v3/initiate',
    createSession: this.server + 'api/payment/order/v3/create',
    unsecCreateSession: this.server + 'api/unsec/payment/order/v3/create',
    commitStatus: this.server + 'api/order/v3/commit',
    unsecCommitStatus: this.server + 'api/unsec/order/v3/commit',
    viewOrderDetail: this.server + 'api/kiosk/order/transaction/v1/view',
    unsecViewOrderDetail: this.server + 'api/unsec/order/v1/view',
    getStoredCardsList: this.server + 'api/payment/cards/v1/list',
    deleteCard: this.server + 'api/payment/card/v1/delete',
    intiateTxnForCash:this.server +'api/kiosk/order/transaction/v1/initiate',
    commitStatusForCash:this.server+'api/kiosk/order/v1/commit',
  };
  public secHeaderData = {
    'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
    'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
  };
  public unsecHeaderData = {
    'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo),
    'GuestToken': localStorage.getItem('guestUserToken')
  };
  constructor(private http: HttpClient, private commonFunction: CommonFunctions, private apiHeader : ApiHeaderService,private storageService:StorageService) {
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
  }
  intiateTxn(requestData) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
     let secHeaderData = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.initiateTxn, requestData, { headers: secHeaderData });
    } else {
      let unsecHeaderData = this.apiHeader.getUnSecureHeader();
      return this.http.post(this.urls.unsecInitiateTxn, requestData, { headers: unsecHeaderData });
    }
  }
  intiateTxnForCash(requestData) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
     let secHeaderData = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.intiateTxnForCash, requestData, { headers: secHeaderData });
    } 
  }

  createSession(requestData) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaderData = {
        'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
        'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
      };
      return this.http.post(this.urls.createSession, requestData, { headers: secHeaderData });
    } else {
      let unsecHeaderData = this.apiHeader.getUnSecureHeader();
      return this.http.post(this.urls.unsecCreateSession, requestData, { headers: unsecHeaderData });
    }
  }
  commitStatus(requestData) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.commitStatus, requestData, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.post(this.urls.unsecCommitStatus, requestData, { headers: unsecureHeaders });
    }
  }
  commitStatusForCash(requestData) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.commitStatusForCash, requestData, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.post(this.urls.unsecCommitStatus, requestData, { headers: unsecureHeaders });
    }
  }

  viewOrderDetails(orderId) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.viewOrderDetail + '?orderId=' + orderId, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.unsecViewOrderDetail + '?orderId=' + orderId, { headers: unsecureHeaders });
    }
  }
  getStoredCards(){
    let user_profile_info = JSON.parse(localStorage.getItem('user_profile'))
    let secHeaderData = {
      'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
      'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
    };
    return this.http.get(this.urls.getStoredCardsList + '?customerId=' + user_profile_info.userId, { headers: secHeaderData });
  }
  deleteCard(requestData){
    return this.http.post(this.urls.deleteCard, requestData, { headers: this.unsecHeaderData });
  }
}
